import Tooltip from '@carvana/showroom-tooltip';
import Tag from '@/SearchResults/ResultTile/Tags/Tag';

const OnHoldTag = () => (
  <Tooltip
    direction="bottom-start"
    display={{
      width: 212
    }}
    content={
      <div className="t-body-s text-grey-2">
        Another customer recently began the process to purchase this vehicle, so
        we’re holding it for them temporarily, just like we will for you.
        Frequently, customers do not move forward during this hold time and the
        vehicle becomes available again.
      </div>
    }
    title="This Vehicle Is On Hold"
  >
    <div
      data-analytics-id="On Hold Tooltip"
      onClick={e => e.preventDefault()}
      className="pointer-events-auto"
    >
      <Tag text="On Hold" bgColor="bg-yellow-2" data-qa="on-hold-badge" />
    </div>
  </Tooltip>
);

export default OnHoldTag;
